import { render, staticRenderFns } from "./ColumnController.vue?vue&type=template&id=4d080caa&lang=pug"
import script from "./ColumnController.vue?vue&type=script&lang=js"
export * from "./ColumnController.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports